<template>
  <div class="chatRecord">
    <div class="chatRecord-content">
        <ul class="chatRecord-content-ul">
            <li v-for="(item,index) in msg_data" :key="index">
                <!-- <div class="chatRecord-content-header">2019-04-03 8:07:9</div> -->
                <div class="chatRecord-content-chat" v-if="item.type=='text'">{{item.text}}</div>
                <div class="chatRecord-content-chat" style="width:200px;height:200px" v-if="item.type=='image'">
                  <img class="image" :src="getimageurl(item.image)" alt="" srcset="">
                </div>
                <div class="chatRecord-content-chat" v-if="item.type=='link'" @click="togo(item.url)">
                  <div class="link">
                    <div class="link-image"><img src="../assets/link.png" alt="" srcset=""></div>
                    <div class="link-content">
                      <p class="link-title">{{item.title}}</p>
                      <p class="link-description wordBreak">{{item.description}}</p>
                    </div>
                  </div>
                </div>

                <div class="chatRecord-content-chat" v-if="item.type=='location'">
                  <div class="location">
                    <div class="location-img">
                      <img src="../assets/address.png" alt="" srcset="">
                    </div>
                    <div class="location-content">
                        <p class="location-content-title">{{item.title}}</p>
                        <p class="location-content-address wordBreak">{{item.address}}</p>
                    </div>
                  </div>
                </div>

                <div class="chatRecord-content-chat" v-if="item.type=='video'" style="width:300px;height:300px">
                  <!-- <video :src="getimageurl(item.video)"></video> -->
                  <video id="myVideo" controls>
                      <source :src="getimageurl(item.video)" type="video/mp4">
                    </video>
                </div>

                <div class="chatRecord-content-chat" v-if="item.type=='file'" @click="todownload(item.sdkfileid,item.fileName)">
                  <div class="file">
                    <div class="file-img">
                      <img src="../assets/file.png" alt="" srcset="">
                    </div>
                    <p class="wordBreak">{{item.fileName}}</p>
                    <!-- <a :href="getimageurl(item.sdkfileid)" :download="item.fileName">点击下载</a> -->
                  </div>
                </div>

            </li>

        </ul>
    </div>


    <!-- <div class="chatRecord-content">
      <ul class="chatRecord-content-ul">
        <li>
          <div class="chatRecord-content-chat">
                  <div class="link">
                    <div class="link-image"><img src="../assets/link.png" alt="" srcset=""></div>
                    <div class="link-content">
                      <p class="link-title">999999</p>
                      <p class="link-description wordBreak">和健康就好好</p>
                    </div>
                  </div>
                </div>
          </li>
        <li>
          <div class="chatRecord-content-chat">
            <div class="location">
              <div class="location-img">
                <img src="../assets/address.png" alt="" srcset="">
              </div>
              <div class="location-content">
                  <p class="location-content-title">哈哈哈哈</p>
                  <p class="location-content-address wordBreak">分享音频 2efd5edbe24c1236280be4157d38ca6c853b7ffbad9ceefea62fea1eb796782a</p>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="chatRecord-content-chat">
            <div class="file">
              <div class="file-img">
                <img src="../assets/file.png" alt="" srcset="">
              </div>
              <p class="wordBreak">分享音频 2efd5edbe24c1236280be4157d38ca6c853b7ffbad9ceefea62fea1eb796782a</p>
            </div>
          </div>
        </li>
        <li>
          <div class="chatRecord-content-chat">
            <div class="file">
              <div class="file-img">
                <img src="../assets/file.png" alt="" srcset="">
              </div>
              <p class="wordBreak">分享音频 2efd5edbe24c1236280be4157d38ca6c853b7ffbad9ceefea62fea1eb796782a</p>
            </div>
          </div>
        </li>
        <li>
          <div class="chatRecord-content-chat">
            <div class="file">
              <div class="file-img">
                <img src="../assets/file.png" alt="" srcset="">
              </div>
              <p class="wordBreak">分享音频 2efd5edbe24c1236280be4157d38ca6c853b7ffbad9ceefea62fea1eb796782a</p>
            </div>
          </div>
        </li>
      </ul>
    </div> -->



    
  </div>
</template>

<script>
import api from "../api/api.js";
export default {
  name: 'chatRecord',
  props: {
    msg: String
  },
  data() {
    return {
      // medata:{"code": 0, "msg": "ok", "data": {"type": "chatList", "title": "", "chatList": [{"type": "image", "image": "CiAyNzVjMmM5YjkzYmQ2NTI5NzVjZDU0OTc5NGIzNjFhNRI4TkRkZk56ZzRNVE13TXpRd016a3dORFF6TUY4eE56UTFPREU1TVRNeFh6RTFPVGN6TWpNM05qUT0aIDlhNWUyYzdiMmVjYTJlN2IzNTcwMjdkZGQ4MzQxMGJl", "userInfo": null}, {"type": "text", "text": "[\u8f6c\u8d26\u6d88\u606f]", "userInfo": null}, {"type": "link", "description": "\u6210\u529f\u7684\u77e5\u8bc6\u5206\u4eab\u8005\uff0c\u4ece\u4e0d\u8d5a\u5feb\u94b1\u3002", "title": "\u666e\u901a\u4eba\u4e00\u5e74\u5982\u4f55\u8d5a\u5230 100 \u4e07\u7f8e\u5143\uff1f", "image_url": "https://imunion.weixin.qq.com/cgi-bin/mmae-bin/tpdownloadmedia?param=v1_ddaef4c356923743d9fd802bcdc811f14db1d448a8923db63fbdd4c0c6e47e634fdc48481493164c7d5c6a9f4490221b95d3ec91ff34b137f1f30901658cb1241a6a6eb4278e21dd34b96e143eeb7d40f261f7d48c1327386372c59f8b286c3757b0b4607cb63798b173b35f20ff21ebda080f36635db06a71181b479c7c0d56702d84a479fefb3cbcac34bebaadaa0b15cd178bd72aa760e35ea379a2b3c575ce85b14903fb9e4f6f451bc3ba6631fa590a185b359707859a65c50871b6a4a08f219069f5cc6eefd977474304ab00685f662d5d7f84448ec1751d615312cf02c2504148793402fc5f05d8c179921092b30d8602eddddd441ce1ddd40cabfd9e5f966b5e264061ee7c9211d969b709aa3d9ca1d59e64651af5b530883d8f01f3524001f5767c6546cdb2de3a79638aaffdd902b34042563269df9556516f8bd7c5592cdfde4557307e3f4f15028ec7d1", "url": "http://mp.weixin.qq.com/s?__biz=MzIwMjU0MzA3NA==&mid=2247489153&idx=1&sn=9497bd54984df1bc70e8ed1900f889fd&chksm=96dc4c0ca1abc51a8f6ac2a2bd85e06c5c75a99db1e29ad6a97b81bf8eea41135ce08e7cbe66&mpshare=1&scene=1&srcid=0804w0sAqI6G2E3eUhYxRVeY&sharer_sharetime=1596477333524&sharer_shareid=d5b72f430f1a048448d576178591be27#rd"}, {"type": "text", "text": "[\u8be5\u6d88\u606f\u7c7b\u578b\u6682\u4e0d\u80fd\u5c55\u793a]", "userInfo": null}, {"type": "text", "text": "\u6211\u662f\u4e00\u6bb5\u6587\u7ae0", "userInfo": null}, {"type": "text", "text": "[\u8bed\u97f3]", "userInfo": null}, {"type": "text", "text": "[\u52a8\u753b\u8868\u60c5]", "userInfo": null}, {"type": "text", "text": "[\u52a8\u753b\u8868\u60c5]", "userInfo": null}, {"type": "location", "title": "\u73e0\u6c5f\u65b0\u57ce[\u5730\u94c1\u7ad9]", "address": "\u5e7f\u4e1c\u7701\u5e7f\u5dde\u5e02\u5929\u6cb3\u533a\u5730\u94c13\u53f7\u7ebf,\u5730\u94c15\u53f7\u7ebf", "latitude": 23.119322, "longitude": 113.321213, "userInfo": null}, {"type": "video", "video": "CiA0MmEyYTA2NjJhZTA1ZDE3ODQxMzVjM2Y4MTM1MjAxNBI4TkRkZk56ZzRNVE13TXpRd016a3dORFF6TUY4eE56WXdOalF3TURZM1h6RTFPVGN6TWpNM05qUT0aIDRhYmU2MzVkMDcyODY4MTNhYjVjNjJkMWQ4MmFjZDBl", "length": 28, "userInfo": null}, {"type": "text", "text": "\u6211\u662f\u4e00\u6bb5\u6587\u5b57", "userInfo": null}, {"type": "file", "sdkfileid": "CiAzZmU1N2UxNjZjYzg4ZjU0NmRmYmFiZTAyNDgxYTdhNhI4TkRkZk56ZzRNVE13TXpRd016a3dORFF6TUY4eE1ETXdORFF3T1RjMlh6RTFPVGN6TWpNM05qUT0aIGEwYTJkNDY0ZTc1NTE1YjAwMmUxOWQxM2RjZTM2MDdk", "fileName": "\u4f01\u4e1a\u5fae\u4fe1\u79c1\u57df\u7ba1\u5bb6\u4ecb\u7ecd_\u8bed\u9e66\u4f01\u670d_20200422\u7248\u672c.pdf", "fileExt": "pdf", "userInfo": null}], "userInfo": null}},
      msg_data:[],
      cid:'',
      token:''
  }},
  mounted() {
    // this.getlist()
    if (this.$route.query.cid&&this.$route.query.token) {
      this.cid=this.$route.query.cid
      this.token=this.$route.query.token
      this.listinit()
    }
    // this.getimageurl()
    // this.msg_data=this.medata
    // console.log(this.medata)
  },
  methods: {
    listinit(){
      api.webChatInfo({
        cid:this.cid,
        token:this.token
      }).then(res=>{
        if(res.data.code=='10005'){
           this.$message.error("查看权限已过期，请刷新收藏列表");
           return
        } 
        if(res.data.code==0){
          this.msg_data=res.data.data.chatList
        }
      })
    },
    getlist(){
      // timeAxislist
      api.timeAxislist({
        page:1,
        nums:20
      }).then(res=>{
          // this.msg_data=res.data.data.chatList
          // console.log('//',res.data.data.chatList)
      })
    },
    getimageurl(val){
      return 'https://wxcollect.api.bytell.cn/timeAxis/webChatMedia?sdkfileid='+val+'&token='+this.token
    },
    togo(val){
      window.open(val)
    },
    todownload(val,fileName){
      var a = document.createElement("a");
      a.href = this.getimageurl(val)
      a.download =fileName
      a.click();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$myWidth: 75;
.name{
  font-size: 18px;
  height: 98rem/$myWidth
}
ul,li{
    padding: 0px;
    margin: 0px;
    list-style: none;
}
.chatRecord-content{
    padding: 20px;
    
}
.wordBreak{
  word-break: break-all;
}
.chatRecord-content-ul{
    font-size: 16px;
    .chatRecord-content-header{
        font-size: 16px;
    }
    li{
      margin: 15px;
      padding: 0 0 15px;
      border-bottom: 1rem/$myWidth solid #e0e0e0;
    }
    .chatRecord-content-chat{
      .image{
        width: auto;  
        height: auto;  
        max-width: 100%;  
        max-height: 100%; 
      }
      video{
        width: 100%;  
        height: 100%;  
        max-width: 100%;  
        max-height: 100%; 
      }
      .link{
        display: flex;
        background-color: #e0e0e0;
        border-radius: 4px;
        .link-image{
          // flex: 1;
          margin: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .link-content{
          flex: 1;
          .link-title{
            font-weight: 600;
          }
          .link-description{

          }
        }
      }
      .file{
        background-color: #e0e0e0;
        border-radius: 4px;
        display: flex;
        padding: 10px;
        box-sizing: content-box;
        .file-img{
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 10px;
          img{
            width: 20px;
            height: 20px;
          }
        }
      }
      .location{
        display: flex;
        background-color: #e0e0e0;
        border-radius: 4px;
        padding: 10px;
        box-sizing: content-box;
        .location-img{
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 10px;
          img{
            width: 20px;
            height: 20px;
          }
        }
        .location-content{
          .location-content-title{
            font-weight: 600;
          }
        }
      }
    }
}

</style>
